module.exports = __webpack_public_path__ + "img/scatter-chart-svgrepo-com-grey.d29fa15b.svg";